import { render, staticRenderFns } from "./AmountSelect.vue?vue&type=template&id=498c3c7e&scoped=true&"
import script from "./AmountSelect.vue?vue&type=script&lang=ts&"
export * from "./AmountSelect.vue?vue&type=script&lang=ts&"
import style0 from "./AmountSelect.vue?vue&type=style&index=0&id=498c3c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498c3c7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('498c3c7e')) {
      api.createRecord('498c3c7e', component.options)
    } else {
      api.reload('498c3c7e', component.options)
    }
    module.hot.accept("./AmountSelect.vue?vue&type=template&id=498c3c7e&scoped=true&", function () {
      api.rerender('498c3c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/AmountSelect.vue"
export default component.exports